function validateType(variableName, variableValue, type) {
    if (typeof variableValue !== type) {
        throw new Error(`Invalid "${variableName}" type. Expected string and received ${typeof variableValue}`);
    }
}
function validateAppConfig(appConfig) {
    if (!appConfig) {
        return;
    }
    validateType('appConfig', appConfig, 'object');
    const { project, name, version } = appConfig;
    validateType('project', project, 'string');
    validateType('name', name, 'string');
    validateType('version', version, 'string');
    if ('type' in appConfig) {
        validateType('type', appConfig.type, 'string');
    }
    if ('developmentState' in appConfig) {
        validateType('developmentState', appConfig.developmentState, 'string');
    }
}
export function validateConfig(config) {
    if ('platform' in config) {
        validateType('platform', config.platform, 'string');
    }
    if ('retriesConfig' in config) {
        validateType('retriesConfig', config.retriesConfig, 'object');
    }
    validateAppConfig(config.appConfig);
}
function getVersionNumber(version) {
    const validVersionRegex = /^\d+.\d+.\d+$/;
    if (validVersionRegex.test(version)) {
        return version;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: Named capturing groups are only available when targeting 'ES2018' or later
    const appVersionRegex = /^[a-zA-Z0-9-_]+@v?(?<version>\d+.\d+.\d+)$/;
    const matched = version.match(appVersionRegex);
    if (matched === null || !('groups' in matched)) {
        return version;
    }
    return matched?.groups?.version ?? version;
}
export function cleanConfig(config) {
    if ('appConfig' in config && typeof config.appConfig !== 'undefined') {
        return {
            ...config,
            appConfig: {
                ...config.appConfig,
                version: getVersionNumber(config.appConfig.version),
            },
        };
    }
    return config;
}
//# sourceMappingURL=utils.js.map